// reCAPTCHA v3 helper — gracefully no-ops when no site key is configured.
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

let scriptPromise = null;

const loadScript = () => {
  if (!SITE_KEY) return Promise.resolve(false);
  if (typeof window === "undefined") return Promise.resolve(false);
  if (window.grecaptcha?.execute) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return scriptPromise;
};

export const getRecaptchaToken = async (action = "submit") => {
  if (!SITE_KEY) return "";
  const ok = await loadScript();
  if (!ok || !window.grecaptcha) return "";
  return new Promise((resolve) => {
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(SITE_KEY, { action });
        resolve(token || "");
      } catch {
        resolve("");
      }
    });
  });
};

export const recaptchaEnabled = () => Boolean(SITE_KEY);
